import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';

import { BusyModule } from 'angular2-busy';
import { ToastrModule } from 'ngx-toastr';

import {DataTableModule} from "angular2-datatable";

import { CustomFormsModule } from 'ng2-validation'
import { MaterializeModule } from 'angular2-materialize';

import { SocketService } from './socket.service';
import { NotificationsService } from './notifications.service';
import { NotificationsComponent } from "./notifications.component";

import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { Ng2TelInputModule } from 'ng2-tel-input';
import { MyDateRangePickerModule } from 'mydaterangepicker';
import {RatingModule} from "ngx-rating";
@NgModule({
  imports: [
    CommonModule
  ],
  exports: [
    HttpModule,
    BusyModule,
    FormsModule,
    CustomFormsModule,
    CommonModule,
    MaterializeModule,
    DataTableModule,
    // Ng2TelInputModule,
    NgxIntlTelInputModule,
    BsDropdownModule,
    NotificationsComponent,
    MyDateRangePickerModule,
    RatingModule
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
  providers: [NotificationsService, SocketService],
  declarations: [NotificationsComponent]
})
export class AppSharedModule { }



// WEBPACK FOOTER //
// C:/Users/Home/OneDrive/Documents/hotellife_web/src/app/shared/app-shared.module.ts